import * as React from "react";
import {Link as GatsbyLink} from "gatsby";
import {useState} from "react";
import cx from "classnames";
import Section from "../Layout/Section";
import {getUrlWithTrailingSlash} from "../../utils/url";
import LinkArrow from "../../assets/svg/link/arrow.svg";
import Media from "../Common/Media";
import PlusSVG from "../../assets/svg/solutionplus.svg";
import Arrow from "../../assets/svg/arrow-current-color.svg";
import * as styles from "./solutions.module.css";

const Solutions = ({items}) => {
    const [showAllSolutions, setShowAllSolutions] = useState(false);
    const sortedItems = [...items].sort((a, b) => a.sortOrder - b.sortOrder);

    return (
        <Section title="Подходит для компаний любых размеров и отраслей" className={styles.solutions}>
            <div className={cx(styles.solutions__list, {[styles.solutions__list_showall]: showAllSolutions})}>
                {sortedItems.map(({id, title, url, icon}) => {
                    return (
                        <GatsbyLink key={id} to={getUrlWithTrailingSlash(url)} className={styles.solutions__link}>
                            <Media media={{content: icon}} className={styles.solutions__linkIcon} />
                            {title}
                            <LinkArrow />
                        </GatsbyLink>
                    );
                })}
                <p className={styles.solutions__more}>
                    <PlusSVG />
                    Другие отрасли
                </p>
            </div>
            <button type="button" className={styles.solutions__button} onClick={() => setShowAllSolutions(true)}>
                Смотреть все отрасли <Arrow />
            </button>
        </Section>
    );
};

export default Solutions;
